import cashDeskInstance from './instance'

const getCartState = (desktopDeviceId) => {
	return cashDeskInstance.get(`/cartState/${desktopDeviceId}`)
}

export default getCartState
